module.exports = function () {
    const header = document.querySelector('.main-header');
    if ( !header ) return;

    const btn = document.getElementById('menu-burger');
    const activeClass = "isOpen";
    const menu = document.querySelector('.main-header__navigation');

    btn.addEventListener('click', function () {
        btn.classList.toggle(activeClass);
        menu.classList.toggle(activeClass);
        header.classList.toggle(activeClass);
    });

    menu.querySelectorAll('a').forEach(function(item) {
        item.addEventListener('click', function () {
            btn.classList.remove(activeClass);
            menu.classList.remove(activeClass);
            header.classList.remove(activeClass);
        });
    });

    window.addEventListener('resize', closeMenu);

    function closeMenu() {
        if (window.innerWidth >= 768) {
            btn.classList.remove(activeClass);
            menu.classList.remove(activeClass);
            header.classList.remove(activeClass);
        }
    }
};